import { Component, ViewChild, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { ApiService } from "src/app/api.service";
declare const BrandVars;

@Component({
	selector: "app-systemlog",
	templateUrl: "./systemlog.component.html",
	styleUrls: ["./systemlog.component.scss"]
})
export class SystemlogComponent implements OnInit {
	@ViewChild("exceptionModal", { static: true }) public exceptionModal: any;

	public brand = BrandVars;

	public totalLogs = 0;
	public currentPage = 1;
	public itemsPerPage = 30;
	public pageLogs: any[] = [];
	public selectedException: any = null;
	public selectedExceptionStack?: string = undefined;
	public selectedExceptionSubStack?: string = undefined;
	public filters: any = {};
	public assetList: any[] = [];
	public selectedAsset: any = null;

	constructor(private modalService: NgbModal, private api: ApiService) { }

	async ngOnInit() {
		const logFilters = localStorage.getItem("logFilters");
		if (logFilters) {
			this.filters = JSON.parse(logFilters);
			this.updatePage();
		} else {
			this.ResetFilters();
		}
		const assetList = await this.api.GetAllAssets();
		assetList.sort((a, b) => {
			if (a.fleet_name === null && b.fleet_name !== null) return 1;
			if (a.fleet_name !== null && b.fleet_name === null) return -1;
			if (a.fleet_name > b.fleet_name) return 1;
			if (a.fleet_name < b.fleet_name) return -1;
			if (a.asset_name > b.asset_name) return 1;
			if (a.asset_name < b.asset_name) return -1;
			return 0;
		});
		this.assetList = assetList;
	}

	async updatePage() {
		let userid: any = null;
		if (this.filters.user) {
			userid = this.filters.user.user_id;
		}
		let deviceid: any = null;
		if (this.filters.device) {
			deviceid = this.filters.device.device_id;
		}
		let assetid: any = null;
		if (this.filters.asset) {
			assetid = this.filters.asset.asset_id;
		}
		const result = await this.api.GetSystemLog(this.itemsPerPage * (this.currentPage - 1), this.itemsPerPage,
			this.filters.environment_name, this.filters.ec2_instance, this.filters.remote_ip, userid, deviceid, assetid, this.filters.status_code, this.filters.http_method, this.filters.path,
			this.filters.only_long_responses ? 200000 : undefined,
			this.filters.ignore_myself, null, this.filters.ignore_users, this.filters.ignore_devices, this.filters.ignore_anonymous, this.filters.ignore_system, this.filters.ignore_import, undefined, this.filters.only_exceptions, this.filters.only_this_environment
		);
		this.totalLogs = result.count;
		this.pageLogs = result.rows;
	}

	refreshTable() {
		this.currentPage = 1;
		localStorage.setItem("logFilters", JSON.stringify(this.filters));
		this.updatePage();
	}

	showException(log: any) {
		try {
			this.selectedExceptionStack = undefined;
			this.selectedException = JSON.parse(log.exception);
			if (this.selectedException.stack) {
				this.selectedExceptionStack = this.selectedException.stack;
				delete this.selectedException.stack;
			}
			if (this.selectedException.detail && this.selectedException.detail.StackTrace) {
				this.selectedExceptionSubStack = this.selectedException.detail.StackTrace;
				delete this.selectedException.detail.StackTrace;
			}
		} catch (ex) {
			this.selectedException = log.exception;
		}
		this.modalService.open(this.exceptionModal, { size: "lg" });
	}

	getRequester(log: any): string {
		if (log.user_email) {
			return log.user_email;
		} else if (log.device_serial) {
			return log.device_serial;
		} else if (log.asset_name) {
			return log.asset_name;
		} else {
			return "";
		}
	}

	applyFilter(field: string, value: any) {
		this.filters[field] = value;
		this.refreshTable();
	}

	applyRequesterFilter(log: any) {
		if (log.user_email) {
			this.filters.user = { user_id: log.user_id, email: log.user_email };
		} else if (log.device_serial) {
			this.filters.device = { device_id: log.device_id, serial: log.device_serial };
		} else if (log.asset_name) {
			this.filters.asset = { asset_id: log.asset_id, name: log.asset_name };
		}
		this.refreshTable();
	}

	removeFilter(field: string) {
		this.filters[field] = null;
		this.refreshTable();
	}

	ResetFilters() {
		this.filters = {
			ignore_myself: false,
			ignore_users: false,
			ignore_devices: false,
			ignore_anonymous: false,
			ignore_system: false,
			ignore_import: false,
			only_long_responses: false,
			only_exceptions: false,
			only_this_environment: true,
		};
		this.selectedAsset = null;
		this.refreshTable();
	}

	async FilterAsset(asset: any) {
		this.filters.asset = {
			asset_id: asset.asset_id,
			name: asset.asset_name,
		};
		this.refreshTable();
	}
}
